import { render, staticRenderFns } from "./NewInputInvoice.vue?vue&type=template&id=5ef2dcde&scoped=true"
import script from "./NewInputInvoice.vue?vue&type=script&lang=js"
export * from "./NewInputInvoice.vue?vue&type=script&lang=js"
import style0 from "./NewInputInvoice.vue?vue&type=style&index=0&id=5ef2dcde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef2dcde",
  null
  
)

export default component.exports